'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.minutesSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/minutesSince.js
// module id = 263
// module chunks = 1